import React from "react";
import ConfigurationMaster from "./ConfigurationMaster";

function ChangeType() {
    return (
        <ConfigurationMaster
            type="changetype"
        />
    );
}

export default ChangeType;